import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppInfoService } from 'core/app-info/app-info.service';
import { AppLocalization } from 'src/app/modules/shared/entities/app-localization';
import { QuoteToolsService } from '../../services/quote-tools.service';

@Component({
  selector: 'app-atp-button',
  templateUrl: './atp-button.component.html',
  styleUrls: ['./atp-button.component.scss'],
  standalone: false
})
export class AtpButtonComponent implements OnInit, OnDestroy {

  @Input() disabled = false;
  refreshingAtp = false;
  toggleValue = false;
  appStrings: AppLocalization;
  productCount = 0;
  private subscriptions = new Subscription();

  constructor(
    private appInfoService: AppInfoService,
    private quoteToolsService: QuoteToolsService
  ) { }

  ngOnInit(): void {
    this.appStrings = this.appInfoService.appStrings;
    this.subscriptions.add(this.quoteToolsService.atpRefresh$.subscribe(() => this.refreshAtp()));
    this.subscriptions.add(this.quoteToolsService.productCount$.subscribe(count => this.productCount = count));
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  /**
   * Refreshes the ATP date for the product list
   */
  refreshAtp() {
    if (this.refreshingAtp || !this.productCount) {
      return;
    }

    this.refreshingAtp = true;
    this.quoteToolsService.atpIsRefreshing$.next(this.refreshingAtp);
    this.quoteToolsService.refreshAtp().subscribe(() =>
      this.quoteToolsService.refreshToolsList$.next(() => {
        this.refreshingAtp = false;
        this.quoteToolsService.atpIsRefreshing$.next(this.refreshingAtp);
      }),
    () => {
      this.refreshingAtp = false;
      this.quoteToolsService.atpIsRefreshing$.next(this.refreshingAtp);
    }
    );
  }
}
